<script lang="ts">
	import { desktopUpdate } from '$lib/desktop.svelte';
</script>

{#if desktopUpdate.phase === 'countdown'}
	<aside class="desktop-update" role="status" aria-live="polite">
		<strong>ANDRESOT для Windows обновлён до {desktopUpdate.version}</strong>
		<span>Приложение перезапустится через {desktopUpdate.seconds} с. Черновики сохранены.</span>
	</aside>
{:else if desktopUpdate.phase === 'deferred' && desktopUpdate.version}
	<aside class="desktop-update" role="status">
		<strong>Обновление {desktopUpdate.version} готово</strong>
		<span>Установим его после завершения звонка, записи или передачи файла.</span>
	</aside>
{/if}

<style>
	.desktop-update {
		position: fixed;
		inset-inline: 50% auto;
		bottom: max(var(--spacing-xl), env(safe-area-inset-bottom));
		z-index: 1000;
		transform: translateX(-50%);
		width: min(32rem, calc(100vw - 2rem));
		display: grid;
		gap: var(--spacing-2xs);
		padding: var(--spacing-m) var(--spacing-l);
		border: 1px solid var(--border-subtle);
		border-radius: var(--radius-l);
		background: var(--background-surface);
		box-shadow: 0 8px 28px #0005;
		color: var(--text-primary);
		font: var(--text-body);
	}
	.desktop-update span {
		color: var(--text-secondary);
	}
</style>
